<template>
  <div class="grid-nav">
    <el-pagination
        @current-change="getCurrentChange"
        @size-change="getSizeChange"
        :current-page="curpage"
        :page-size="article"
        layout="total, prev, pager, next, jumper"
        :total="pageTotal"
      >
      </el-pagination>
  </div>
</template>

<script>
  export default {
    name: "drageGridNav",
    props: {
      //- 序号
      subScript: {
        type: Number,
        required: false,
        default: 0
      },
      //- 是否可以点击
      disabled: {
          type: Boolean,
          default: false
      },
      //- 条数
      article: {
        type: Number,
        default: 20
      },
      //- 第几页
      curpage: {
        type: Number,
        default: 1
      },
      //- 总数
      pageTotal: {
        type: Number,
        default: 0
      },

    },
    data () {
      return {
        dropdownList: [25, 50, 100],
        pageValue: 1//- 当前数据总页数
      }
    },
    methods:{
      getSizeChange (val) {
        console.log('getSizeChange:', val)
      },
      getCurrentChange (val) {
        console.log('getCurrentChange:', val)
        // this.curpage = val
        this.$emit("pageChange",{index:this.subScript,curpage: val})
      },
      //- input数据变换
      inputChange(){
        let curpage = parseInt(this.curpage);
        if(curpage > 0 && curpage <= Math.ceil(this.pageTotal/this.article)){
          this.$emit("pageChange",{index:this.subScript,curpage: curpage})
        }else{
          this.$message({
            message: '页数输入错误,还原为1',
            type: 'warning'
          });
          this.$emit("pageChange",{index:this.subScript,curpage: 1})
        }
      },
      //- 判断总页数
      panduan(pageTotal,article){
        let showValue = Math.ceil(pageTotal/article);
        this.pageValue = showValue;
        return showValue;
      },
      //- 选择页数
      dropdownFun (command) {
        // this.article = command;
        this.$emit("pageChange",{index:this.subScript,article: command})
      },
      //- 上一页
      pre(){
        let curpage = parseInt(this.curpage);
        if(curpage <= 1){
          this.$message({
            message: '没有了哦',
            type: 'warning'
          });
        }else{
          this.$emit("pageChange",{index:this.subScript,curpage: curpage - 1})
        }
      },
      //- 下一页
      next(){
        let curpage = parseInt(this.curpage);
        let pageValue = parseInt(this.pageValue);
        if(curpage >= pageValue){
          this.$message({
            message: '到底了哦',
            type: 'warning'
          });
        }else{
          this.$emit("pageChange",{index:this.subScript,curpage: curpage + 1})
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  :deep(.el-button--mini) {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }
 
  .grid-nav {
    display: flex;
    align-items: center;
    justify-content: right;
    :deep(.el-pagination__total), :deep(.el-pagination__jump) {
      color: #9B9B9B;
    }
    :deep(.btn-prev) {
      border: 1px solid #EDEDED;
      border-radius: 4px;
      padding-right: 6px;
      margin-right: 8px;
    }
    :deep(.btn-next) {
      padding-left: 6px;
    }
    :deep(.el-pager li) {
      height: 24px;
      line-height: 24px;
      min-width: 24px;
      margin-right: 5px;
    }
    :deep(.el-pager li), :deep(.btn-next) {
      border: 1px solid #EDEDED;
      border-radius: 4px;
    }
    :deep(.el-pager .active) {
      background-color: #38A2FB;
      border-color: #38A2FB;
      margin-right: 8px;
    }
    :deep(button) {
      min-width: 24px;
      height: 24px;
      line-height: 24px;
    }
    :deep(.el-pagination span:not([class*=suffix])) {
      line-height: 24px;
      height: 24px;
    }
    :deep(.el-pagination__editor.el-input .el-input__inner) {
      height: 24px;
    }
  }
  .grid-nav-left {
    min-width: 146px;
  }
  .el-dropdown-link {
    border-radius:4px;
    border:1px solid rgba(217,217,217,1);
    padding: 5px 12px;
    display: inline-block;
    font-size:14px;
    cursor: pointer;
  }
  .date-strip {
    font-size:14px;
    color:rgba(0,0,0,0.65);
    padding-left: 10px;
  }
  .grid-input {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    text-align: center;
    width: 37px;
    height: 26px;
    line-height: 26px;
    outline: 0;
    padding: 0 1px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  }
  .strip-stat {
    font-size:14px;
    color:rgba(0,0,0,0.65);
    padding-left: 5px;
    padding-right: 10px;
  }
  .button-width {
    width: 38px;
  }
</style>
